import { createRoot } from 'react-dom/client'
import { IconsProvider } from '@talkdesk/cobalt-react-icon'
import ViewportProvider from '@talkdesk/cobalt-react-viewport-provider'
import ThemeProvider from '@talkdesk/cobalt-react-theme-provider'
import RouterRoot from './root'
import theme from '@talkdesk/cobalt-theme-light'
import { ErrorBoundary } from 'react-error-boundary'

window.TalkdeskApps = window.TalkdeskApps || {}

const appRoots = new WeakMap()

window.TalkdeskApps.TalkdeskIdLoginUi = {
  start: function(rootElement, params) {
    const existing = appRoots.get(rootElement)
    if (existing) {
      existing.unmount()
      appRoots.delete(rootElement)
    }
    appRoots.set(rootElement, startApp(rootElement, params))
  },
  stop: function(rootElement) {
    const existing = appRoots.get(rootElement)
    if (existing) {
      existing.unmount()
      appRoots.delete(rootElement)
    }
  },
  version: __APP_VERSION__
}

function startApp(rootElement, params) {
  const { themeVersion } = params
  let themeLoader

  if (themeVersion) {
    console.log(`Using theme version: ${themeVersion}`)
    themeLoader = async () => Promise.resolve(null)
  } else {
    console.log('Using default theme')
    themeLoader = async () => Promise.resolve(theme)
  }

  const root = createRoot(rootElement)
  root.render(
    <ErrorBoundary
      fallback={<div />}
      onError={(error, errorInfo) =>
        console.log(`Error: ${error}, Error Info: ${errorInfo}`)
      }
    >
      <ViewportProvider>
        <ThemeProvider loader={themeLoader}>
          <IconsProvider>
            <RouterRoot {...params} />
          </IconsProvider>
        </ThemeProvider>
      </ViewportProvider>
    </ErrorBoundary>
  )
  return root
}
